// src/components/modals/ZoomModal.jsx
import React from 'react';
import { X } from 'lucide-react';

export const ZoomModal = ({ imageUrl, onClose }) => (
  <div className="fixed inset-0 bg-black/95 z-[600] flex items-center justify-center p-4" onClick={onClose}>
    <button onClick={onClose} className="absolute top-4 right-4 text-white p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all">
      <X size={24}/>
    </button>
    <img src={imageUrl} className="max-w-full max-h-full rounded-lg object-contain" alt="zoom" onClick={e => e.stopPropagation()}/>
  </div>
);